import { H_HYDRO_MODULE, H_INSTALLATION_MODULE, H_PIEZO_MODULE, H_PLUVIO_MODULE, H_PRODUCTION_MODULE, H_QUALITO_MODULE } from 'account/constants/AccessRulesConstants'
import { keyBy } from 'lodash'
import { STATION_TYPE_NAME } from 'station/constants/StationConstants'

const OBSERVATORY_MODULE_ID = -99
const WIDGET_MODULE_ID = -98

const OBSERVATORY = {
    id: 1,
    name: 'Observatoire',
    conventionalName: 'obs', // Also used in line 68 of the UserController of the Authorization service
    moduleTypeId: OBSERVATORY_MODULE_ID,
}

const DEFAULT_WIDGET = {
    id: 2,
    name: 'Widget',
    conventionalName: 'widget', // Also used in line 68 of the UserController of the Authorization service
    moduleTypeId: WIDGET_MODULE_ID,
}

const WIDGET_CARTO = {
    id: 3,
    name: 'Widget Cartographique',
    conventionalName: 'widgetcarto', // Also used in line 68 of the UserController of the Authorization service
    moduleTypeId: WIDGET_MODULE_ID,
}

const WIDGET_STATION = {
    id: 4,
    name: 'Widget Station',
    conventionalName: 'widgetstation', // Also used in line 68 of the UserController of the Authorization service
    moduleTypeId: WIDGET_MODULE_ID,
}

const WIDGET = {
    ...DEFAULT_WIDGET,
    modules: [WIDGET_CARTO, WIDGET_STATION],
}

const WIDGETS = [DEFAULT_WIDGET, WIDGET_CARTO, WIDGET_STATION]
const MODULES = [OBSERVATORY, ...WIDGETS]

const INDEXED_MODULES = keyBy(MODULES, 'conventionalName')

const OBSERVATORY_STATION_TYPE_NAME = {
    CATCHMENT: {
        moduleKey: 'CAPTAGE',
        habs: [H_PIEZO_MODULE, H_PRODUCTION_MODULE],
        labelKey: STATION_TYPE_NAME.catchment,
    },
    PIEZOMETER: {
        moduleKey: 'PIEZOMETER',
        habs: [H_PIEZO_MODULE],
        labelKey: STATION_TYPE_NAME.piezometry,
    },
    HYDROMETRIC_STATION: {
        moduleKey: 'HYDROMETRIC_STATION',
        habs: [H_HYDRO_MODULE],
        labelKey: STATION_TYPE_NAME.hydrometry,
    },
    PLUVIOMETER: {
        moduleKey: 'PLUVIOMETER',
        habs: [H_PLUVIO_MODULE],
        labelKey: STATION_TYPE_NAME.pluviometry,
    },
    QUALITOMETER: {
        moduleKey: 'QUALITOMETER',
        habs: [H_QUALITO_MODULE],
        labelKey: STATION_TYPE_NAME.quality,
    },
    PRODUCTION_UNIT: {
        moduleKey: 'PRODUCTION_UNIT',
        habs: [H_PRODUCTION_MODULE],
        labelKey: STATION_TYPE_NAME.productionUnit,
    },
    INSTALLATION: {
        moduleKey: 'INSTALLATION',
        habs: [H_INSTALLATION_MODULE],
        labelKey: STATION_TYPE_NAME.installation,
    },
}

const MODULE_PARAMETER = 'moduleUrl'

export {
    OBSERVATORY,
    WIDGET_CARTO,
    WIDGET_STATION,
    MODULES,
    OBSERVATORY_STATION_TYPE_NAME,
    OBSERVATORY_MODULE_ID,
    WIDGET_MODULE_ID,
    WIDGET,
    WIDGETS,
    INDEXED_MODULES,
    MODULE_PARAMETER,
}